import { sample } from 'lodash';

/**
 * 生成指定长度有数字和字母组成随机字符串
 * @param {*} length
 * @returns
 */
export function generateRandomString(length = 10) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < length; i++) {
    result += sample(characters);
  }
  return result;
}
